import request from '@/lib/request/'

const baseUri = 'merged_news/'

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function postSort (data) {
  return request({
    url: baseUri + 'sort',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/merged_news/index.js